<script setup>
import { ref, onMounted, computed } from 'vue'
import AppLinkCard from '../components/layouts/AppLinkCard.vue';
import AppCard from '../components/layouts/AppCard.vue';
import ChildCard from '../components/ChildCard.vue';
import { useAuthStore, useAssessmentsStore } from '../stores';
import { useRouter } from 'vue-router'
import AppPreviewCard from '../components/layouts/AppPreviewCard.vue';
import { shortDate } from '../helpers/utils'

const router = useRouter()

const assessmentsStore = useAssessmentsStore();
const authStore = useAuthStore()
const assessments = ref([])

onMounted(async () => {
    await assessmentsStore.fetchReadinessReportCards()
    assessments.value = assessmentsStore.getAssessments
})

const displayAssessments = computed(() => {
    const childAssessments = assessmentsStore.getReportCardsByChildId(parseInt(authStore.currentChildId))
    if (authStore.currentChild && authStore.currentChild.current_readiness_report_card) {
        const index = childAssessments.findIndex(rrc => parseInt(rrc.id) == parseInt(authStore.currentChild.current_readiness_report_card.id));
        if (index >= 0) {
            const [item] = childAssessments.splice(index, 1);
            // childAssessments.unshift(item);
        }
        return childAssessments
    } else {
        return childAssessments
    }
})

const dashboardClickHandler = () => {
    if (authStore.currentChild.current_readiness_report_card) {
        router.push(`/readiness/report-card/${authStore.currentChild.current_readiness_report_card.id}`)
    } else {
        assessmentsStore.createReadinessReportCard(authStore.currentChildId)
    }
}

const achievedMilestonesInWords = (readinessMap) => {
    const mapped = Object.values(readinessMap).reduce((accum, curr) => {
        return { achieved: accum.achieved + curr.milestones.achieved.length, total: accum.total + curr.milestones.total }
    }, { achieved: 0, total: 0 })
    return `${mapped.achieved}/${mapped.total} Milestones`
}

const borderColorString = () => {
    const colorScheme = ['border-primary', 'border-secondary', 'border-tertiary', 'border-accent']
    // return `${colorScheme[Math.floor(Math.random() * colorScheme.length)]}`
    return colorScheme[Math.floor(Math.random() * colorScheme.length)]
}


</script>
<template>
    <div class="mx-2">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center items-center content-start">
            <div v-if="authStore.children.length < 1">
                <AppLinkCard :body="`Add a child before starting a readiness challenge.`" to="/account/child/new"
                    header="Add a Child" />
            </div>
            <div v-else-if="authStore.currentChild">
                <ChildCard :child="authStore.currentChild" :detailView="true" />
                <!-- this whacky conditional is a temp. dashboard. Should display: 0. aggregate information 1. cont. current assessment or 2. start new assessment -->
                <!-- Dashboard Card -->
                <!-- v-if="!authStore.currentChild.current_readiness_report_card" -->
                <!-- :body="`Awesome! You've completed ${displayAssessments.length} readiness challenge and learned (n) skills since (date)! Click below to ${authStore.currentChild.current_readiness_report_card ? 'continue the current' : 'start a new'} readiness assessment.`"> -->
                <AppCard
                    :header="`${authStore.currentChild.current_readiness_report_card ? authStore.currentChild.current_readiness_report_card.title : `Unlock your child's potential!`}`"
                    :body="`${authStore.currentChild.current_readiness_report_card ? `` : `Start a new Readiness Assessment to find out what milestones your child is ready to achieve.`}`">
                    <div class="gap-2 sm:grid sm:grid-cols-2 font-normal "
                        v-if="authStore.currentChild.current_readiness_report_card">
                        <dl v-for="readinessArea in Object.values(authStore.currentChild.current_readiness_report_card.readiness_map)"
                            :key="readinessArea.readiness_area.id">
                            <dt class="text-xs ">
                                <div class="flex flex-row justify-between text-gray-500">
                                    <div>
                                        {{ readinessArea.readiness_area.title.replace('Development', 'Milestones') }}
                                    </div>
                                    <div>
                                        {{ readinessArea.milestones.achieved.length }}/{{ readinessArea.milestones.total }}
                                    </div>
                                </div>
                            </dt>
                            <span class="text-sm font-medium text-gray-500 "></span>
                        </dl>
                    </div>
                    <AppPreviewCard
                        @clicked.once="router.push(`/readiness/report-card/${authStore.currentChild.current_readiness_report_card.id}`)"
                        v-if="authStore.currentChild.current_readiness_report_card">
                        <div class="grid grid-flow-col justify-stretch content-center text-primary font-normal">
                            <div :class="`border border-4 bg-white-200 rounded-full ${borderColorString()} w-6 h-6 `"></div>
                            <div class="">Continue</div>
                        </div>
                    </AppPreviewCard>
                    <AppPreviewCard @clicked.once="assessmentsStore.createReadinessReportCard(authStore.currentChildId)"
                        v-else>
                        <div class="grid grid-flow-col justify-stretch content-center text-primary font-normal">
                            <div :class="`border border-4 bg-white-200 rounded-full ${borderColorString()} w-6 h-6 `"></div>
                            <div class="">New Assessment</div>
                        </div>
                    </AppPreviewCard>
                </AppCard>
                <AppCard header="Pending Milestones" v-if="authStore.currentChild.current_readiness_report_card">
                    <div class="max-h-44 overflow-y-auto">
                        <div v-for="milestone in authStore.currentChild.current_readiness_report_card.incomplete_milestones">
                            <AppPreviewCard @clicked="''">
                            <div class="grid grid-flow-col justify-stretch content-center items-center text-xs ">
                                {{ milestone.title }}
                            </div>
                            </AppPreviewCard>
                        </div>
                        <!-- Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. -->
                    </div>
                </AppCard>
                <AppCard header="Calendar" v-if="false">
                    <div class="max-h-24 overflow-y-auto">
                        <!-- Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. -->
                    </div>
                </AppCard>
                <AppCard :header="`${authStore.currentChild.first_name}'s Previous Readiness Assessments`"
                    v-if="displayAssessments.length">
                    <div v-for="(readinessReportCard, index) in displayAssessments">
                        <AppPreviewCard @clicked="router.push(`/readiness/report-card/${readinessReportCard.id}`)">
                            <div class="grid grid-flow-col justify-stretch content-center items-center text-xs ">
                                <div :class="`text-gray-500`">{{ shortDate(readinessReportCard.created_at) }}</div>
                                <div class="mr-1.5 text-gray-500">{{
                                    readinessReportCard.short_title }}</div>
                                <div class="text-gray-500 justify-self-end">{{
                                    achievedMilestonesInWords(readinessReportCard.readiness_map)
                                }}</div>
                            </div>
                        </AppPreviewCard>
                    </div>
                </AppCard>
            </div>
        </div>
    </div>
</template>